import Domains from './Domains';

const DefaultValues = {
  bidder_pmp_attributes: {
    auction_type: "1",
    bidfloorcur: "USD",
    priceScale: 0
  },
  domains: [Domains.tmn_tag, Domains.ramp]
};

export default DefaultValues;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/StaticData/DefaultValues.tsx